import { ReactComponent as HarvestIcon } from './harvest.svg';

export default HarvestIcon;
